import apiClient from '../services/apiClient';

export interface CartProduct {
  id: string;
  name: string;
  price: number;
  barcode: string;
  image_url: string | null;
}

export interface CartItem {
  id: string;
  product_id: string;
  quantity: number;
  product: CartProduct;
}

export interface Cart {
  id: string;
  business_id: string;
  cart_items: CartItem[];
  total_amount: number;
}

export interface CheckoutRequest {
  payment_method: string;
  amount: number;
  customer_phone?: string;
  customer_type?: string | null;
  discount?: number;
  notes?: string;
  mpesa_code?: string;
  idempotencyKey?: string;
}

export interface CheckoutResponse {
  sale: any;
  receipt: any;
  mpesa?: boolean;
}

export interface PaymentStatusResponse {
  status: 'pending' | 'completed' | 'failed';
  resultCode?: string;
  message?: string;
}

export const fetchCart = async (businessId: string): Promise<Cart> => {
  const response = await apiClient.get(`/cart/${businessId}`);
  return response.data;
};

export const updateCartItemQuantity = async (businessId: string, itemId: string, quantity: number): Promise<void> => {
  await apiClient.put(`/cart/${businessId}/items/${itemId}`, { quantity });
};

export const removeCartItem = async (businessId: string, itemId: string): Promise<void> => {
  await apiClient.delete(`/cart/${businessId}/items/${itemId}`);
};

export const addCartItem = async (businessId: string, productId: string, quantity: number): Promise<void> => {
  await apiClient.post(`/cart/${businessId}/add`, { productId, quantity });
};

export const scanCartItem = async (businessId: string, barcode: string): Promise<any> => {
  const response = await apiClient.post(`/cart/${businessId}/scan`, { barcode });
  return response.data;
};

export const checkoutCart = async (businessId: string, request: CheckoutRequest): Promise<CheckoutResponse> => {
  const response = await apiClient.post(`/cart/${businessId}/checkout`, request, { timeout: 30000 });
  return response.data;
};

export const checkPaymentStatus = async (businessId: string, saleId: string): Promise<PaymentStatusResponse> => {
  const response = await apiClient.get(`/cart/${businessId}/sales/${saleId}/check-payment`, { timeout: 10000 });
  return response.data;
};

export const retryPayment = async (businessId: string, saleId: string): Promise<void> => {
  await apiClient.post(`/cart/${businessId}/sales/${saleId}/retry-payment`);
};
